<i18n>
  zh-TW: {}
  en: {}
  ja: {}
  ko: {}
</i18n>

<script>
import { ScrollNavBar } from '../index'
import ScrollContent from './scroll-content'
export default {
  components: {
    ScrollNavBar,
    ScrollContent
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      path: this.$route.path,
      isRecordScroll: false
    }
  },
  computed: {
    labels() {
      if (!this.data.length) return []
      return this.data?.map((group) => group.name)
    }
  },
  watch: {
    activeIndex(index) {
      // 记忆页面滚动位置
      localStorage.setItem(`scrollIndex-${this.path}`, index)
    }
  },
  updated() {
    if (this.$refs['scroll-content'] && !this.isRecordScroll) {
      this.recordScroll()
    }
  },
  methods: {
    // 记忆页面滚动位置
    recordScroll() {
      const index = +localStorage.getItem(`scrollIndex-${this.path}`) || 0
      this.$refs['scroll-content'].scrollToContent(index)
      this.activeIndex = index
      this.isRecordScroll = true
    },
    change(index) {
      this.activeIndex = index
      this.$refs['scroll-content'].scrollToContent(index)
    },
    contentScrollChange(index) {
      this.activeIndex = index
    }
  },
  render() {
    return (
      <div class="scroll-module">
        <scroll-nav-bar
          class="scroll-nav-bar"
          active-index={this.activeIndex}
          labels={this.labels}
          onChange={this.change}
        />
        <scroll-content
          class="scroll-content"
          ref="scroll-content"
          data={this.data}
          on-content-scroll-change={this.contentScrollChange}
        />
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
.scroll-nav-bar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  height: 96px;
  background-color: rgb(0, 0, 0);
  /deep/ .item {
    padding: 0 54px;
    color: #bdbdbd;
    font-size: 28px;
    font-family: PingFangHK-Light;
    font-weight: 300;
  }
  /deep/ .active {
    color: rgb(1, 194, 195);
    font-size: 32px;
    font-family: PingFang HK;
    font-weight: 500;
    background-color: rgb(43, 43, 43);
  }
}
.scroll-content {
  padding: 0 40px 40px;
}
</style>
